import {
  adjacentTeethSchema,
  archTeethSchema,
  manyTeethSchema,
  mixedTeethSchema,
  uniqueTeethSchema,
  type DeepPartial,
  type ItemType,
  type Product,
  type ProductType,
} from "@jasper/client-models";
import type { WorkflowStep } from "./types";
import type { StepKeys } from "../../steps";

export type TeethSelection = "ADJACENT" | "UNIQUE" | "MIXED" | "ARCH" | "MANY";

export const TeethSelectionEnum: Record<TeethSelection, TeethSelection> = {
  ADJACENT: "ADJACENT",
  UNIQUE: "UNIQUE",
  MIXED: "MIXED",
  ARCH: "ARCH",
  MANY: "MANY",
} as const;

const teethSchemaByTeethSelection = {
  [TeethSelectionEnum.UNIQUE]: uniqueTeethSchema,
  [TeethSelectionEnum.ADJACENT]: adjacentTeethSchema,
  [TeethSelectionEnum.MIXED]: mixedTeethSchema,
  [TeethSelectionEnum.ARCH]: archTeethSchema,
  [TeethSelectionEnum.MANY]: manyTeethSchema,
};

export const isTeethStepComplete = ({
  teeth,
  teethSelection,
}: {
  teeth?: Readonly<number[]> | number[];
  teethSelection: TeethSelection;
}) => {
  return teethSchemaByTeethSelection[teethSelection].safeParse(teeth).success;
};

export type WorkflowProduct = {
  type: ProductType;
  items?: DeepPartial<Product>["items"];
};

export interface ProductWorkflowConfiguration<
  TProduct extends Product,
  TStepKey extends StepKeys,
> {
  readonly productType: ProductType;
  readonly steps: ReadonlyArray<WorkflowStep<TStepKey>>;
  readonly itemType: ItemType;
  readonly teethSelection: TeethSelection;
  readonly isBulkSupported: boolean;
  readonly isBulkCompatible?: (
    leaderProduct: DeepPartial<Product>,
    followerProduct: DeepPartial<Product>
  ) => boolean;

  getCompletedSteps(product: DeepPartial<TProduct>): TStepKey[];
  isValidProduct(product: DeepPartial<TProduct>): boolean;
}
